import { useState } from 'react';
import styled from 'styled-components';
import LogoIcon from '@/assets/mo/Logo.svg?react';
import HamburgerIcon from '@/assets/mo/Toc.svg?react';
import SideDrawer from './SideDrawer';
import { useNavigate } from 'react-router-dom';

const MobileHeader = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <HeaderContainer>
        <LeftArea>
          <HamburgerButton onClick={() => setMenuOpen(true)}>
            <HamburgerInner>
              <HamburgerIcon width={24} height={24} />
            </HamburgerInner>
          </HamburgerButton>
          <LogoArea onClick={() => navigate('/')}>
            <LogoIcon width={24} height={24} />
          </LogoArea>
        </LeftArea>

        <RightArea>
          <CallButton
            onClick={() => {
              window.location.href = 'https://nicetomeetyou.oopy.io';
            }}
          >
            전화 상담
          </CallButton>
          <ApplyButton onClick={() => navigate('/appointment')}>무료 선임 신청</ApplyButton>
        </RightArea>
      </HeaderContainer>

      {menuOpen && <SideDrawer onClose={() => setMenuOpen(false)} />}
    </>
  );
};

export default MobileHeader;

const HeaderContainer = styled.header`
  position: fixed; /* ✅ 상단 고정 */
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* ✅ 다른 요소 위에 보이게 */

  display: flex;
  width: 100%;
  height: 56px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
`;

const LogoArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6.891px;
`;

const RightArea = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ApplyButton = styled.button`
  display: flex;
  height: 26px;
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  border-radius: 4px;
  background: var(--Primary-brand_01, #0b46dd);
  cursor: pointer;

  color: var(--Primary-white, #fff);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.28px;
`;

const CallButton = styled.button`
  display: flex;
  height: 26px;
  padding: 8px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border: none;
  border-radius: 4px;
  background: var(--states-red, #f42d16);
  cursor: pointer;

  color: var(--Primary-white, #fff);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 16.8px */
  letter-spacing: -0.28px;
`;

const HamburgerButton = styled.button`
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

const HamburgerInner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const LeftArea = styled.div`
  display: flex;
  align-items: center;
`;
